import { SubsystemNodeIcon, ChannelNodeIcon, SensorNodeIcon } from './ConsoleSvg';

type Props = {
  depth: number;
  label: string;
  nodeName: string;
  nodeType: "subsystem" | "channel" | "sensor";
  fullPath: string;
  hasChildren: boolean;
  isLastChild: boolean;
  ancestorRails: boolean[];
  hasChildFailure?: boolean;
  status?: string;
};

export function ValidationParameterLabel({
  depth,
  label,
  nodeName,
  nodeType,
  fullPath,
  hasChildren,
  isLastChild,
  ancestorRails,
  hasChildFailure,
  status,
}: Props) {
  const d = Math.max(0, Math.min(depth, 16));

  const rails = ancestorRails.slice(0, d).map((hasRail, i) => (
    <span
      key={i}
      className={`output__validation__tree-rail ${
        hasRail ? "output__validation__tree-rail--active" : ""
      }`}
    />
  ));

  const isIndex = /^\d+$/.test(label);

  return (
    <span
      className={`output__validation__param-label ${
        hasChildren ? "output__validation__param-label--parent" : ""
      } ${hasChildFailure ? "output__validation__param-label--failure" : ""}`}
    >
      <span className="output__validation__tree-guides">
        {rails}
        {d > 0 && (
          <span
            className={`output__validation__tree-branch ${
              isLastChild ? "output__validation__tree-branch--last" : ""
            }`}
          />
        )}
      </span>
      <span className="output__validation__content-wrap" title={fullPath}>
        <span
          className={`output__validation__icon output__validation__icon--${nodeType} ${
            status?.toLowerCase().trim() === "fail" || hasChildFailure ? "output__validation__icon--failure" : ""
          } ${status?.toLowerCase().trim() === "pass" ? "output__validation__icon--success" : ""} ${
            status?.toLowerCase().trim() === "timeout" || status?.toLowerCase().trim() === "timed_out" || status?.toLowerCase().trim() === "timedout" ? "output__validation__icon--timeout" : ""
          }`}
        >
          {nodeType === "subsystem" ? (
            <SubsystemNodeIcon />
          ) : nodeType === "channel" ? (
            <ChannelNodeIcon />
          ) : (
            <SensorNodeIcon />
          )}
        </span>
        <span
          className={`output__validation__param-text ${
            isIndex ? "output__validation__param-text--index" : ""
          }`}
        >
          {nodeName}
        </span>
      </span>
    </span>
  );
}
